(function() {
  var WidgetTopicToggle = function() {
    var expandBtn,
      container;

    var _init = function() {
      expandBtn = document.querySelector('.topic-toggle');
      container = expandBtn.parentNode.parentNode;

      expandBtn.addEventListener('click', _onExpandBtnClick);
    };

    var _onExpandBtnClick = function(e) {
      if (container.classList.contains('active')) {
        container.classList.remove('active');
      } else {
        container.classList.add('active');
      }
    };

    return {
      init: _init
    }
  }();

  if (document.querySelector('.topic-toggle')) {
    WidgetTopicToggle.init();
  }
})();

